<ng-container *ngIf="activeTimer">
    <div class="vf-timer-indicator">

        <!-- Row 1: status dot + label + stop -->
        <div class="vf-timer-indicator__header">
            <span class="vf-timer-indicator__dot"></span>
            <span class="vf-timer-indicator__label show-in-expanded">Recording</span>
            <button
                class="vf-timer-indicator__stop show-in-expanded"
                (click)="stopTimer()"
                [disabled]="isStopping"
                title="Stop timer">
                <lucide-icon name="square" [size]="10" [strokeWidth]="2" class="fill-white"></lucide-icon>
                <span>Stop</span>
            </button>
            <button
                class="vf-timer-indicator__stop vf-timer-indicator__stop--slim count-in-slim"
                (click)="stopTimer()"
                [disabled]="isStopping"
                title="Stop timer">
                <lucide-icon name="square" [size]="12" [strokeWidth]="2" class="fill-white"></lucide-icon>
            </button>
        </div>

        <!-- Row 2: task name -->
        <button class="vf-timer-indicator__task show-in-expanded" (click)="openTask()" title="{{ activeTimer?.taskName }}">
            {{ taskNameDisplay }}
        </button>

        <!-- Row 3: elapsed -->
        <span class="vf-timer-indicator__elapsed show-in-expanded">{{ elapsed }}</span>

    </div>
</ng-container>
